// Variant 1
// if (window.ab180v1) {
//     clearInterval(window.ab180v1);
// }
// window.ab180v1 = setInterval(function () {
//     if (document.querySelector('body')) {
//         // Add class to body
//         document.querySelector('body').classList.add('ab180-v1');
//         // Clear
//         clearInterval(window.ab180v1);
//     }
// });

// // Variant 2
// if (window.ab180v2) {
//     clearInterval(window.ab180v2);
// }
// window.ab180v2 = setInterval(function () {
//     if (document.querySelector('body')) {
//         // Add class to body
//         document.querySelector('body').classList.add('ab180-v2');
//         // Clear
//         clearInterval(window.ab180v2);
//     }
// });

export const ab180 = (function () {
  const init = function () {
    const hideAndShow = () => {
      const button = document.getElementById("show-options-btn");

      if (button) {
        button.addEventListener("click", function () {
          const options = document.querySelector(".variant-control");

          if (options) {
            options.classList.toggle("active");
            button.classList.toggle("active");
          }
        });
      }
    };

    hideAndShow();
  };

  return {
    init: init,
  };
})();
